import ReorderSubCategoryDialog from "@/components/Assessments/ReorderSubCategoryDialog";
import SubCategory from "@/components/Assessments/SubCategory";
import SubCategorySelect from "@/components/Assessments/SubCategorySelect";
import { Button } from "@/components/ui/button";
import { FormValues } from "@/schema/console/assessments/create/FormValues";
import { AddSquareRegular } from "@fluentui/react-icons";
import { useEffect } from "react";
import { useController, useFieldArray, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { v1 as uuid } from "uuid";

interface CategoryProps {
  index: number;
  type: "simple" | "regular";
}

function Category({ index, type }: CategoryProps) {
  const { t } = useTranslation();
  const { control, setValue } = useFormContext<FormValues>();

  const {
    fields: subCategoryFields,
    append,
    remove,
    replace,
  } = useFieldArray({
    control,
    name: `categories.${index}.subcategories`,
    keyName: "key",
  });

  const subCategoryCount = subCategoryFields.length;

  useEffect(() => {
    const lastSubCategory = subCategoryFields[subCategoryCount - 1];
    if (lastSubCategory) {
      setValue(`categories.${index}.selectedSubCategory`, lastSubCategory.id);
    }
  }, [subCategoryCount]);

  const { field: selectedCategoryField } = useController({
    control,
    name: `categories.${index}.selectedSubCategory`,
  });

  return (
    <div>
      <div className="flex items-center justify-between border-b bg-white p-4">
        <div className="flex items-center gap-2">
          <div className="font-medium text-cool-gray-600">
            {t("sub-categories")}
          </div>
          <SubCategorySelect categoryIndex={index} />
        </div>
        <div className="flex items-center gap-4">
          <ReorderSubCategoryDialog
            categoryIndex={index}
            onReorderFinish={(subcategories) => replace(subcategories)}
          />
          <Button
            variant="text"
            size="zero"
            onClick={() => {
              append({
                id: uuid(),
                content: "",
                isEdit: true,
                questions: [],
              });
            }}
          >
            <AddSquareRegular fontSize={20} className="mr-1 text-cyan-600" />
            <span className="text-cyan-600">{t("add-subCategory")}</span>
          </Button>
        </div>
      </div>
      <div className="p-6">
        {subCategoryFields.map(
          (subCategory, subCategoryIndex) =>
            selectedCategoryField.value === subCategory.id && (
              <SubCategory
                type={type}
                onRemove={() => remove(subCategoryIndex)}
                key={subCategoryIndex}
                index={subCategoryIndex}
                categoryIndex={index}
              />
            ),
        )}
      </div>
    </div>
  );
}

export default Category;
